"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUOTER_CONTRACT_ADDRESS = exports.POOL_FACTORY_CONTRACT_ADDRESS = void 0;
// This file stores web3 related constants such as addresses, token definitions, ETH currency references and ABI's
// Addresses
var POOL_FACTORY_CONTRACT_ADDRESS = '0x1F98431c8aD98523631AE4a59f267346ea31F984';
exports.POOL_FACTORY_CONTRACT_ADDRESS = POOL_FACTORY_CONTRACT_ADDRESS;
var QUOTER_CONTRACT_ADDRESS = '0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6';
exports.QUOTER_CONTRACT_ADDRESS = QUOTER_CONTRACT_ADDRESS;